export const translation = {
    measureLabels: {
        Any: 'Any',
        Avg: 'Avg',
        StdDev: 'StdDev',
        StdDevPop: 'StdDevPop',
        Var: 'Var',
        VarPop: 'VarPop',
        Kurtosis: 'Kurtosis',
        Min: 'Min',
        Median: 'Median',
        Mode: 'Mode',
        Max: 'Max',
        Sum: 'Sum',
        Count: 'Count',
        CountDistinct: 'CountDistinct',
        ApproxCountDistinct: 'ApproxCount',
        Skew: 'Skew'
    },
    transformationStackEntry: {
        Any: 'any({{ sourceColumnName }})',
        Avg: 'avg({{sourceColumnName}})',
        StdDev: 'std_dev({{sourceColumnName}})',
        StdDevPop: 'std_dev_pop({{sourceColumnName}})',
        Var: 'var({{sourceColumnName}})',
        VarPop: 'var_pop({{sourceColumnName}})',
        Kurtosis: 'kurtosis({{sourceColumnName}})',
        Skew: 'skew({{sourceColumnName}})',
        Min: 'min({{sourceColumnName}})',
        Median: 'median({{sourceColumnName}})',
        Mode: 'mode({{sourceColumnName}})',
        Max: 'max({{sourceColumnName}})',
        Sum: 'sum({{sourceColumnName}})',
        Count: 'count(1)',
        CountDistinct: 'count({{sourceColumnName}})',
        ApproxCountDistinct: 'approx_count({{sourceColumnName}})'
    }
};
